import React, { useCallback, useEffect, useState } from 'react';
import { getMainAxios } from '../utils/util';
import ResearchDocViewer from './ResearchDocViewer';

interface EvidenceItem {
  id: string;
  title: string;
  baseline?: string;
}

interface ListRes {
  evidence: EvidenceItem[];
}

interface DocRes {
  id: string;
  content: string;
}

export default function ResearchEvidence() {
  const [items, setItems] = useState<EvidenceItem[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [doc, setDoc] = useState<DocRes | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const axios = getMainAxios();
        const res = await axios.get<ListRes>('/api/v1/research/evidence');
        const list = res.data?.evidence ?? [];
        setItems(list);
        if (list.length > 0) setSelectedId(list[0].id);
      } catch (e: unknown) {
        setError(String(e));
      }
    })();
  }, []);

  const loadDoc = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const axios = getMainAxios();
      const res = await axios.get<DocRes>(`/api/v1/research/evidence/${id}`);
      setDoc(res.data);
    } catch (e: unknown) {
      setError(String(e));
      setDoc(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (selectedId) loadDoc(selectedId);
  }, [selectedId, loadDoc]);

  return (
    <div style={{ padding: 16, textAlign: 'left' }}>
      <h2 style={{ margin: '0 0 8px', fontSize: 18 }}>Evidence</h2>
      <p style={{ margin: '0 0 16px', color: '#64748b', fontSize: 13 }}>
        검증·백테스트 근거 — 설계 Appendix 요약
      </p>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: '0 0 240px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          {items.map(it => (
            <button
              key={it.id}
              type="button"
              onClick={() => setSelectedId(it.id)}
              style={{
                textAlign: 'left',
                padding: '10px 12px',
                borderRadius: 8,
                border: selectedId === it.id ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                background: selectedId === it.id ? '#eff6ff' : '#fff',
                cursor: 'pointer',
                fontSize: 12,
              }}
            >
              {it.title}
              {it.baseline && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4 }}>{it.baseline}</div>}
            </button>
          ))}
        </div>
        <div style={{ flex: '1 1 400px' }}>
          {error && <p style={{ color: '#dc2626', fontSize: 12 }}>{error}</p>}
          {loading && <p style={{ color: '#64748b' }}>로딩…</p>}
          {!loading && doc?.content && <ResearchDocViewer content={doc.content} />}
        </div>
      </div>
    </div>
  );
}
